import React, { useEffect, useReducer, useState, useMemo } from "react";
import rtlPlugin from "stylis-plugin-rtl";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import { prefixer } from "stylis";
import { Box } from "@mui/system";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Check from "@mui/icons-material/Check";
import {
  Alert,
  Autocomplete,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { useMediaQuery } from "react-responsive";
import { getRequest, postRequest } from "../request";
import getReq from "../interface/getRequestinterface";
import postReq from "../interface/postRequestinterface";
import { toast } from "react-toastify";
import Loading from "./loading";
import { useNavigate } from "react-router-dom";

const style = {
  formTitle: {
    fontWeight: "bold !important",
  },
  formDescription: {
    color: "#9b9b9b",
  },
  formContainer: {
    padding: "1rem !important",
    border: "3px solid #748DA6",
    borderRadius: "10px",
    backgroundColor: "#f1f7ff59",
    height: "fit-content",
  },
  gridBox: {
    display: "grid",
    gridTemplateColumns: "40% 40%",
    columnGap: "5%",
    rowGap: "3%",
    justifyContent: "space-around",
  },
  mobileGridBox: {
    display: "grid",
    gridTemplateColumns: "90%",
    // columnGap:'5%',
    rowGap: "3%",
    justifyContent: "center",
    marginTop: "2rem",
  },
  modalStyle: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    p: 4,
    bgcolor: "background.paper",
  },
  txtField: {
    width: "100%",
  },
  headerContainer: {
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
  },
  stateHandler: {
    display: "flex",
  },
  stateType: { fontWeight: "bold" },
};
interface customerDetails {
  address: string;
  agentFirstName: string;
  agentLastName: string;
  phoneNumber: string;
  email: string;
  industry: number;
  companyAlias: string;
  registerNumber: string;
  nationalId: string;
  ceoFullname: string;
  customerType: number;
}

interface Industry {
  id: number;
  label: string;
}

const customerType = [
  { type: 0, label: "حقیقی" },
  { type: 1, label: "حقوقی" },
  { type: 2, label: "مشتری خارجی" },
];

function CustomerDefineName() {
  const [industryList, setIndustryList] = useState<Array<Industry>>([]);
  const [indus, setIndus] = useState<Industry>({ id: 0, label: "" });
  const [isDataLoaded, setIsDataLoaded] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const initialState: customerDetails = {
    address: "",
    agentFirstName: "",
    agentLastName: "",
    phoneNumber: "",
    email: "",
    industry: -1,
    companyAlias: "",
    registerNumber: "",
    nationalId: "",
    ceoFullname: "",
    customerType: 0,
  };
  const [state, dispatch] = useReducer(reducer, initialState);
  function reducer(state, action) {
    switch (action.type) {
      case "UPDATE":
        return {
          ...state,
          [action.key]: action.value,
        };
      case "ADD":
        return action.value;
      default:
        return state;
    }
  }

  const userId = localStorage.getItem("user");
  const isDesktop = useMediaQuery({
    query: "(min-width: 1224px)",
  });

  const isTablet = useMediaQuery({
    query: "(max-width: 768px)",
  });

  const isMobile = useMediaQuery({
    query: "(max-width: 400px)",
  });

  const rtl = useMemo(() => {
    return createCache({
      key: "muirtl",
      stylisPlugins: [prefixer, rtlPlugin],
    });
  }, []);
  useEffect(() => {
    getIndustryList();
  }, []);

  useEffect(() => {
    if (industryList.length) {
      getCustomerInfo();
      setTimeout(() => {
        setIsLoading(true);
      }, 2000);
    }
  }, [industryList]);

  const getCustomerInfo = async () => {
    const { data, error }: getReq = (await getRequest(
      `${process.env.REACT_APP_BASE_URL}/Customer/GetCustomers`
    )) as getReq;
    if (!error) {
      setIndus({
        id: data.industry,
        label: industryList.find((x) => x.id === data.industry)?.label!,
      });
      dispatch({
        type: "ADD",
        value: data,
      });
      setIsDataLoaded(true);
      // setCustomerProps(data.map(x=>({id:x.id,label:x.title})));
    } else {
      toast.error(error);
    }
  };
  const getIndustryList = async () => {
    const { data, error }: getReq = (await getRequest(
      `${process.env.REACT_APP_BASE_URL}/Customer/Industries`
    )) as getReq;
    if (!error) {
      setIndustryList(data.map((x) => ({ id: x.id, label: x.title })));
    } else {
      toast.error(error);
    }
  };
  const submitHandler = async () => {
    if (state.email.length) {
      const emailValidation = state.email
        ?.toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
      if (!emailValidation && !emailValidation?.length) {
        toast.error("ایمیل صحیح نیست!");
        return;
      }
    }
    const mobileValidation = state.phoneNumber?.match(
      /^(\+\d{1,3}[- ]?)?\d{11}$/
    );
    if (mobileValidation && mobileValidation.length) {
      if (state.nationalId.length <= 11 && state.nationalId.length >= 10) {
        const tempData = {
          address: state.address,
          agentFirstName: state.agentFirstName,
          agentLastName: state.agentLastName,
          phoneNumber: state.phoneNumber,
          email: state.email,
          industry: state.industry,
          companyAlias: state.companyAlias,
          registerNumber: state.registerNumber,
          nationalId: state.nationalId,
          ceoFullname: state.ceoFullname,
          customerType: state.customerType,
        };
        const { data, error }: postReq = (await postRequest(
          `${process.env.REACT_APP_BASE_URL}/Customer/UpdateCustomers`,
          tempData
        )) as postReq;
        if (!error) {
          toast.success("اطلاعات با موفقیت ثبت گردید!");
          navigate(0);
        } else {
          toast.error(error);
        }
      } else {
        toast.error("کد ملی صحیح نیست!");
      }
    } else {
      toast.error("شماره تماس صحیح نیست!");
    }
  };
  const handleChangeName = (e) => {
    dispatch({
      type: "UPDATE",
      value: e.target.value,
      key: e.target.name,
    });
  };

  return (
    <CacheProvider value={rtl}>
      <div className="background" style={{ alignItems: "center" }}>
        {isLoading ? (
          <>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                marginTop: "2rem",
              }}
            >
              <Alert
                severity="info"
                sx={{
                  marginBottom: "4rem",
                  display: "flex",
                  alignItems: "center",
                  width: "80%",
                }}
              >
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                  <Typography variant="h4" sx={{ fontWeight: "bold" }}>
                    {" "}
                    اطلاعات تکمیلی مشتری
                  </Typography>
                </Box>
              </Alert>
            </Box>
            <Box sx={{ marginTop: "3rem" }}>
              <Box sx={isDesktop ? style.gridBox : style.mobileGridBox}>
                <TextField
                  label="نام"
                  name="agentFirstName"
                  value={state.agentFirstName}
                  onChange={(e) => handleChangeName(e)}
                />
                <TextField
                  label="نام خانوادگی"
                  name="agentLastName"
                  value={state.agentLastName}
                  onChange={(e) => handleChangeName(e)}
                />
                <TextField
                  label="نام مستعار"
                  name="companyAlias"
                  value={state.companyAlias}
                  onChange={(e) => handleChangeName(e)}
                />
                <TextField
                  label="نام مدیر عامل"
                  name="ceoFullname"
                  value={state.ceoFullname}
                  onChange={(e) => handleChangeName(e)}
                />
                {indus.label === "" ? (
                  <Autocomplete
                    options={industryList}
                    renderInput={(params) => (
                      <TextField {...params} value={indus} label="صنعت" />
                    )}
                    onChange={(event, newValue) => {
                      if (!newValue) {
                        // setCustomerProps({...customerProps,industry:-1})
                        dispatch({
                          type: "UPDATE",
                          value: -1,
                          key: "industry",
                        });
                      } else {
                        dispatch({
                          type: "UPDATE",
                          value: newValue?.id!,
                          key: "industry",
                        });
                        // setCustomerProps({...customerProps,industry:newValue?.id!});
                      }
                    }}
                    // defaultValue={industryList.find(x=>x.id === state.industry)}
                    value={indus}
                    // value={state.industry}
                  />
                ) : (
                  <Autocomplete
                    options={industryList}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        value={industryList.find(
                          (x) => x.id === state.industry
                        )}
                        label="صنعت"
                      />
                    )}
                    onChange={(event, newValue) => {
                      if (!newValue) {
                        // setCustomerProps({...customerProps,industry:-1})
                        dispatch({
                          type: "UPDATE",
                          value: -1,
                          key: "industry",
                        });
                      } else {
                        dispatch({
                          type: "UPDATE",
                          value: newValue?.id!,
                          key: "industry",
                        });
                        // setCustomerProps({...customerProps,industry:newValue?.id!});
                      }
                    }}
                    // defaultValue={industryList.find(x=>x.id === state.industry)}
                    value={industryList.find((x) => x.id === state.industry)}
                    // value={state.industry}
                  />
                )}
                {!isDataLoaded ? (
                  <FormControl fullWidth>
                    <InputLabel>نوع مشتری</InputLabel>
                    <Select
                      value={state.customerType}
                      label="نوع مشتری"
                      name="customerType"
                      onChange={(e) => handleChangeName(e)}
                    >
                      <MenuItem value={0}>حقیقی</MenuItem>
                      <MenuItem value={1}>حقوقی</MenuItem>
                      <MenuItem value={2}>مشتری خارجی</MenuItem>
                    </Select>
                  </FormControl>
                ) : (
                  <FormControl fullWidth>
                    <InputLabel>نوع مشتری</InputLabel>
                    <Select
                      value={
                        state.customerType === -1
                          ? undefined
                          : state.customerType
                      }
                      label="نوع مشتری"
                      name="customerType"
                      onChange={(e) => handleChangeName(e)}
                    >
                      <MenuItem value={0}>حقیقی</MenuItem>
                      <MenuItem value={1}>حقوقی</MenuItem>
                      <MenuItem value={2}>مشتری خارجی</MenuItem>
                    </Select>
                  </FormControl>
                )}

                <TextField
                  label="شماره ثبتی"
                  name="registerNumber"
                  value={state.registerNumber}
                  onChange={(e) => handleChangeName(e)}
                />
                <TextField
                  label="شناسه ملی"
                  name="nationalId"
                  value={state.nationalId}
                  disabled={isDataLoaded}
                  onChange={(e) => handleChangeName(e)}
                />
                <TextField
                  label="ایمیل"
                  name="email"
                  value={state.email}
                  onChange={(e) => handleChangeName(e)}
                />
                <TextField
                  label="شماره تماس"
                  name="phoneNumber"
                  value={state.phoneNumber}
                  onChange={(e) => handleChangeName(e)}
                />
                <TextField
                  label="آدرس"
                  multiline
                  rows={3}
                  name="address"
                  value={state.address}
                  onChange={(e) => handleChangeName(e)}
                />
                <Button
                  variant="contained"
                  color="primary"
                  sx={{ width: "fit-content", height: "fit-content" }}
                  onClick={submitHandler}
                  disabled={
                    !state.address ||
                    !state.agentFirstName ||
                    !state.agentLastName ||
                    !state.industry ||
                    !state.nationalId ||
                    !state.phoneNumber ||
                    !state.registerNumber ||
                    state.customerType === -1
                  }
                >
                  ثبت <Check />
                </Button>
              </Box>
            </Box>
          </>
        ) : (
          <div
            style={{
              width: "100vw",
              height: "calc( 100vh - 64px)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Loading type="cylon" color="#000" />
          </div>
        )}
      </div>
    </CacheProvider>
  );
}

export default CustomerDefineName;
